import Cookies from 'js-cookie';

import { FSForm } from '../../../tools/form-config/index';
import destroyStyles from './destroyStyles';
import excludedDomains from './excludedEmailDomains';

export const whenRenderedCallback = (form) => {
  if (typeof window === 'undefined' || !form) return;
  destroyStyles(form);
  ['mktoForms2BaseStyle', 'mktoForms2ThemeStyle'].forEach((id) => {
    let s = document.getElementById(id);
    if (s) {
      s.remove();
    }
  });
  (async () => {
    const el = form.getFormElem()[0];
    await FSForm(el, 'contact-form');
  })();
};

export const loadFormCallback = async (form, _isMounted, onSuccess, slug) => {
  if (!form) {
    return;
  }
  const formId = form.getId();
  emailValidationHook(form);
  form.onSuccess(() => {
    if (form.__formOnSuccessEventsSet) return;
    form.__formOnSuccessEventsSet = true;
    sessionStorage.removeItem('ab.c.id');
    sessionStorage.removeItem('ab.c.name');
    sessionStorage.removeItem('ab.v.id');
    sessionStorage.removeItem('ab.v.name');

    if (_isMounted && !!onSuccess) {
      if (typeof window !== 'undefined' && !!window.FS) {
        const email = form.getValues()?.Email;
        const displayName = form.getValues()?.FirstName + ' ' + form.getValues()?.LastName;
        window.FS.identify(email, {
          email,
          displayName,
        });
      }
      onSuccess(form);
    }
    return false;
  });
  form.onSubmit(() => {
    if (form.__formOnSubmitEventsSet) return;
    form.__formOnSubmitEventsSet = true;
    // handle abtasty fields
    const fieldKeys = Object.keys(form.vals());

    if (fieldKeys.indexOf('aBTCampaignId') > -1) {
      form.vals({ aBTCampaignId: sessionStorage?.getItem('ab.c.id') });
    }
    if (fieldKeys.indexOf('aBTCampaignName') > -1) {
      form.vals({ aBTCampaignName: sessionStorage?.getItem('ab.c.name') });
    }
    if (fieldKeys.indexOf('aBTVariationID') > -1) {
      form.vals({ aBTVariationID: sessionStorage?.getItem('ab.v.id') });
    }
    if (fieldKeys.indexOf('aBTVariationName') > -1) {
      form.vals({ aBTVariationName: sessionStorage?.getItem('ab.v.name') });
    }
    if (form.vals().mostRecentAssetDownload === '' && slug) {
      form.vals({ mostRecentAssetDownload: slug });
    }
    const selectedProduct = document.querySelector('[data-selected-product]')?.getAttribute('data-selected-product');
    if (selectedProduct) {
      form.vals({
        UTM_Product__c: ProductFieldMap[selectedProduct],
        Product_of_Interest__c: ProductFieldMap[selectedProduct],
      });
    }
    if (!!window.FS) {
      window.FS.event('Marketo Form', {
        type: 'Form submitted',
        formID: (formId && formId.toString()) || '',
      });
    }
    let consent;
    if (!!window.Osano) {
      consent = window.Osano?.cm?.getConsent();
    }
    if (consent?.MARKETING === 'ACCEPT' && !!window?._6si) {
      try {
        const values = form.getValues();
        window._6si.push(['sendFormData', values]);
      } catch (e) {
        console.log(e);
      }
    }
  });
  if (!!window.FormsPlus) {
    window.FormsPlus.onSubmitError(function (error) {
      if (!!window.FS) {
        window.FS.event('Marketo Form', {
          type: 'Form submit error',
          formID: (formId && formId.toString()) || '',
          error,
        });
      }
    });
  }
};

export const ProductFieldMap = {
  AN: 'Leverage AI-powered behavioral analytics',
  analytics: 'Leverage AI-powered behavioral analytics',
  SA: 'Leverage AI to take action faster',
  'Story AI': 'Leverage AI to take action faster',
  WF: 'Improve employee productivity and reduce tech spend',
  workforce: 'Improve employee productivity and reduce tech spend',
  AW: 'Integrate behavioral data into tech stack',
  anywhere: 'Integrate behavioral data into tech stack',
};

const handleProductOfInterest = (form, productOfInterest) => {
  // id=How_can_we_help_you__c
  // id=Product_of_Interest__c
  if (typeof window === 'undefined') return;

  const howHelpField = window.document.getElementById('How_can_we_help_you__c');
  const urlParams = new URLSearchParams(window.location.search);
  const productUtm = urlParams.get('utm_product');
  const fsProduct = urlParams.get('fs_product');
  const selectedProduct = document.querySelector('[data-selected-product]')?.getAttribute('data-selected-product');

  if (howHelpField || productUtm || fsProduct || selectedProduct) {
    if (fsProduct || productUtm) {
      form.setValues({ Product_of_Interest__c: ProductFieldMap[fsProduct || productUtm] });
    } else if (selectedProduct) {
      form.setValues({
        UTM_Product__c: ProductFieldMap[selectedProduct],
        Product_of_Interest__c: ProductFieldMap[selectedProduct],
      });
    } else {
      form.setValues({ Product_of_Interest__c: ProductFieldMap[productOfInterest] });
    }
  }
  if (howHelpField && (productUtm || fsProduct)) {
    howHelpField.addEventListener('change', (event) => {
      if (['Demo', 'Pricing'].indexOf(event?.target?.value) > -1) {
        const productField = window?.document?.getElementById('Product_of_Interest__c');
        if (
          productField &&
          productField.parentElement &&
          productField.parentElement.parentElement &&
          productField.parentElement.parentElement.parentElement &&
          howHelpField.parentElement.parentElement.parentElement
        ) {
          productField.parentElement.parentElement.parentElement.style.display = 'none';
          //howHelpField.parentElement.parentElement.parentElement.style.display = 'none';
        }
        productField.parentElement.parentElement.parentElement.style.display = 'none';
        if (fsProduct || productUtm) {
          form.setValues({ Product_of_Interest__c: ProductFieldMap[fsProduct || productUtm] });
        } else {
          form.setValues({ Product_of_Interest__c: ProductFieldMap[productOfInterest] });
        }
      }
    });
  }
};

export const whenReady = async (form, addHiddenFields, start, skipEmailValidation, productOfInterest) => {
  if (form.__formWhenReadyEventsSet) return;
  form.__formWhenReadyEventsSet = true;
  //destroyStyles(form);
  if (!skipEmailValidation) emailValidationHook(form);
  const formId = form.getId();

  if (addHiddenFields) {
    form.addHiddenFields({ mostRecentAssetDownload: document.location.href });
  }
  form.addHiddenFields({ formUrl: document.location.href });
  const urlParams = new URLSearchParams(window.location.search);
  const productUtm = urlParams.get('utm_product');
  const fsProduct = urlParams.get('fs_product');
  const selectedProduct = document.querySelector('[data-selected-product]')?.getAttribute('data-selected-product');
  if ((!!productOfInterest && productOfInterest !== 'None') || productUtm || fsProduct || selectedProduct) {
    handleProductOfInterest(form, productOfInterest);
  }

  const originalReferrer = Cookies.get('_fs_oreferrer');
  if (originalReferrer) {
    form.addHiddenFields({ originalReferrer });
  }

  // Hide hidden inputs
  const rows = document.querySelectorAll('.mktoFormRow');
  if (rows && rows.length > 0) {
    rows.forEach((row) => {
      if (row.children[0] && row.children[0].type === 'hidden') {
        row.style.display = 'none';
      }
    });
  }
  const end = performance.now();
  if (!!window.FS) {
    window.FS.event('Marketo Form', {
      type: 'Form Loaded',
      formID: (formId && formId.toString()) || '',
      loadTime: end - start,
    });
  }
};

export const emailValidationHook = (form) => {
  if (form.__emailValidationSet) return; // ✅ prevent duplicates
  form.__emailValidationSet = true;
  form.onValidate(() => {
    const formId = form.getId();
    if (formId === 1064 && form.vals().Email !== '') {
      // blog subscription
      form.submittable(true);
      return;
    }
    const email = form.vals()?.Email;
    // const freeMailLong =
    //   /^([A-Za-z0-9.!#$%&’*+/=?^_`{|}~-]+@(?!gmail\.[a-z]{2,})(?!yahoo\.[a-z]{2,})(?!outlook\.[a-z]{2,})(?!hotmail\.[a-z]{2,})(?!aol\.[a-z]{2,})(?!icloud\.[a-z]{2,})(?!protonmail\.[a-z]{2,})(?!zoho\.[a-z]{2,})(?!yandex\.[a-z]{2,})(?!gmx\.[a-z]{2,})(?!inbox\.[a-z]{2,})(?!fastmail\.[a-z]{2,})(?!mail\.ru)(?!tutanota\.[a-z]{2,})(?!hushmail\.[a-z]{2,})(?!runbox\.[a-z]{2,})(?!lavabit\.[a-z]{2,})(?!email\.[a-z]{2,})(?!aol\.co\.uk)(?!orange\.[a-z]{2,})(?!comcast\.[a-z]{2,})(?!verizon\.[a-z]{2,})(?!shaw\.[a-z]{2,})(?!telus\.[a-z]{2,})(?!rogers\.[a-z]{2,})(?!bell\.[a-z]{2,})(?!btinternet\.[a-z]{2,})(?!ntlworld\.[a-z]{2,})(?!sky\.[a-z]{2,})(?!o2\.[a-z]{2,})(?!live\.[a-z]{2,})(?!msn\.[a-z]{2,})(?!hotmail\.co\.uk)(?!mailchimp\.[a-z]{2,})(?!mailbox\.[a-z]{2,})(?!t-online\.[a-z]{2,})(?!blueyonder\.[a-z]{2,})(?!freenet\.[a-z]{2,})(?!web\.[a-z]{2,})(?!arcor\.[a-z]{2,})(?!laposte\.[a-z]{2,})(?!wanadoo\.[a-z]{2,})(?!sbcglobal\.[a-z]{2,})(?!att\.[a-z]{2,})(?!earthlink\.[a-z]{2,})(?!charter\.[a-z]{2,})(?!optimum\.[a-z]{2,})(?!cox\.[a-z]{2,})(?!roadrunner\.[a-z]{2,})(?!icloud\.co\.uk)(?!ymail\.[a-z]{2,})(?!mailinator\.[a-z]{2,})(?!guerrillamail\.[a-z]{2,})(?!myway\.[a-z]{2,})(?!mail2web\.[a-z]{2,})(?!europe\.[a-z]{2,})(?!rediffmail\.[a-z]{2,})(?!tiscali\.[a-z]{2,})(?!alice\.[a-z]{2,})(?!talktalk\.[a-z]{2,})(?!vodafone\.[a-z]{2,})(?!epost\.[a-z]{2,})(?!posteo\.[a-z]{2,})(?!hush\.[a-z]{2,})(?!mailfence\.[a-z]{2,})(?!startmail\.[a-z]{2,})(?!countermail\.[a-z]{2,})(?!netcourrier\.[a-z]{2,})(?!smtp\.[a-z]{2,})(?!ilovemail\.[a-z]{2,})(?!bluewin\.[a-z]{2,})(?!gawab\.[a-z]{2,})(?!list\.[a-z]{2,})(?!webmail\.[a-z]{2,})(?!c2i\.[a-z]{2,})(?!t-online\.[a-z]{2,})(?!citymail\.[a-z]{2,})(?!superposta\.[a-z]{2,})(?!getnada\.[a-z]{2,})([\w-]+\.)+[\w-]{2,25})?$/i;

    const bannedDomainsSet = new Set(excludedDomains);

    function isEmailBanned(email) {
      const plusRegex = /^[^+@]+@[^@]+\.[^@]+$/;
      const domain = email.split('@')?.[1];
      return plusRegex.test(email) && bannedDomainsSet.has(domain);
    }

    /*function emailContainsPlus(email) {
      const plusRegex = /^[^+@]+@[^@]+\.[^@]+$/;
      return !plusRegex.test(email);
    }*/

    /*const freeMail =
      /^([A-Za-z0-9.!#$%&’*+/=?^_`{|}~-]+@(?!yahoo\.com)(?!hotmail\.com)(?!live\.com)(?!aol\.com)(?!msn\.com)(?!outlook\.com)(?!gmail\.com)(?!bellsouth\.net)(?!icloud\.com)([\w-]+.)+[\w-]{2,25})?$/i;*/
    const competitorEmails =
      /^([A-Za-z0-9.!#$%&’*+/=?^_`{|}~-]+@(?!hotjar\.com)(?!logrocket\.com)(?!crazyegg\.com)(?!inspectlet\.com)(?!luckyorange\.com)(?!mouseflow\.com)(?!userreplay\.com)(?!glassbox\.com)(?!sessioncam\.com)(?!decibel\.com)(?!contentsquare\.com)(?!quantummetric\.com)(?!clicktale\.com)(?!tealeaf\.com)(?!acousticanalytics\.com)(?!acoustic\.com)(?!amplitude\.com)(?!heap\.com)(?!pendo\.com)(?!smartlook\.com)(?!mixpanel\.com)(?!uxcam\.com)(?!datadog\.com)(?!dynatrace\.com)(?!glassboxdigital\.com)(?!omeie\.com)([\w-]+.)+[\w-]{2,25})?$/i;

    const isFreeMailTrial = isEmailBanned(email);
    const isFreeMail = isEmailBanned(email); //!freeMail.test(email);
    const isCompetitor = !competitorEmails.test(email);

    //TODO: Consider putting this in Contentful's site settings
    const demoEmailInvalid = email && (isFreeMail || isCompetitor);

    const trialEmailInvalid = formId === 2456 && email && isFreeMailTrial;

    const scorecardEmailInvalid = formId === 2627 && email && isFreeMail;

    //const containsPlus = emailContainsPlus(email);

    if (demoEmailInvalid || trialEmailInvalid || scorecardEmailInvalid) {
      if (typeof window !== 'undefined' && !!window.FS) {
        window.FS.event('Marketo Form', {
          type: 'Form validation issues',
          freeTried: email,
          formID: form.getId().toString(),
        });
      }
      form.submittable(false);
      const emailElem = form.getFormElem().find('#Email');
      let formMessage = 'Please submit a business email address.';
      if (isCompetitor) formMessage = 'We apologize, but it appears that you are not authorized to submit this form.';
      //if (containsPlus) formMessage = 'Please remove the plus sign (+) from your email address.';
      form.showErrorMessage(formMessage, emailElem);
    } else {
      form.submittable(true);
    }
  });
};
